export default __webpack_public_path__ + "static/media/logo.069fd8da.svg";